<template>
	<span aria-hidden="true">
		<img src="../../img/icons/arrow-expand.svg" alt=""/>
	</span>
</template>

<script>
export default {}
</script>

